module.exports = __webpack_public_path__ + "img/report_accept.b6f61ad8.png";